module.exports = (__webpack_require__(11))(64);


//////////////////
// WEBPACK FOOTER
// delegated ../../node_modules/isomorphic-fetch/fetch-npm-browserify.js from dll-reference vendor_lib
// module id = 249
// module chunks = 0